// name of module store
export const STORE_MODULE_AGENT_CREATION = 'agent-creation';

// module events
export const AGENT_CREATED = 'agent-created';
